import React from 'react'
import style from './EquipmentThermoplastics.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const EquipmentThermoplastics = () => {
  const { t } = useTranslation()
  return (
    <div className={style.engineering} id={'thermoplastik'}>
      <div className={`${'customContainer'} ${style.engineering_wrap}`}>
        <h2 className={style.title}>{t('equipmentThermoplastics.title')}</h2>
        <p className={style.desc}>{t('equipmentThermoplastics.desc')}</p>
        <Link to={'/engineering/thermoplastic'} className={style.button}>
          {t('equipmentThermoplastics.button')}
        </Link>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default EquipmentThermoplastics
